import { z } from 'zod';

/**
 * Decodes a JSON record into a plain `Map`. Use when the key schema outputs a
 * primitive (e.g. the branded `BookYear` string), where `===` keying works;
 * `objectMapFromRecord` is the `ObjectMap` twin for structural (class) keys.
 */
const mapFromRecord = <KeySchema extends z.ZodType, ValueSchema extends z.ZodType>(
  keySchema: KeySchema,
  valueSchema: ValueSchema,
) =>
  z.record(z.string(), valueSchema).transform((record, ctx) => {
    const map = new Map<z.infer<typeof keySchema>, z.infer<typeof valueSchema>>();
    for (const [key, value] of Object.entries(record)) {
      const parsedKey = keySchema.safeParse(key);

      if (parsedKey.data) {
        map.set(parsedKey.data, value);
      } else if (parsedKey.error) {
        ctx.addIssue({ code: 'custom', message: parsedKey.error.message });
      }
    }

    return map;
  });

export { mapFromRecord };
